import { SpeakingDemoIframe } from "@/components/seo/SpeakingDemoIframe";

interface SeoEmbeddedLanguageLearningAppProps {
  initialTargetLanguageParam?: string | null;
  initialInstructionLanguageParam?: string | null;
  pageFamily: string;
  pagePath: string;
  requireTargetLanguageSelection?: boolean;
}

export function SeoEmbeddedLanguageLearningApp({
  initialTargetLanguageParam,
  initialInstructionLanguageParam,
  pageFamily,
  pagePath,
  requireTargetLanguageSelection = false,
}: SeoEmbeddedLanguageLearningAppProps) {
  return (
    <div className="overflow-hidden rounded-3xl border border-white/10 bg-[#0f0f14] shadow-2xl shadow-black/30">
      <SpeakingDemoIframe
        defaultTargetLanguageCode={initialTargetLanguageParam}
        defaultInstructionLanguageCode={initialInstructionLanguageParam}
        pageFamily={pageFamily}
        pagePath={pagePath}
        placement="primary_practice"
        requireTargetLanguageSelection={requireTargetLanguageSelection}
        loading="eager"
      />
    </div>
  );
}
